// The four destinations, and the rail around them.
export const nav = {
  // ── nav / chrome ─────────────────────────────────────────────────────
  'nav.brand.name': 'پارسینا',
  'nav.brand.panel': 'پنل دانشجو و دستیار',
  'nav.items.patients': 'بیماران',
  'nav.items.chat': 'گفتگو',
  'nav.items.credits': 'پارسه',
  'nav.items.profile': 'پروفایل',
  'nav.sidebar.collapse': 'بستن منو',
  'nav.sidebar.expand': 'باز کردن منو',
  'nav.sidebar.logout': 'خروج از حساب',
  'nav.sidebar.editProfile': 'پروفایل',
  'nav.sidebar.shortcuts': 'میانبرهای صفحه‌کلید',
  'nav.balance.label': 'موجودی',
  'nav.landmark.primary': 'منوی اصلی',
  'nav.landmark.content': 'محتوا',
};

export default nav;
